
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(229|313|499|723)|2(058|44|471)|1(094|280|484)|8(003|219|227|431|849)|7(193|414|850|92)|3181|5313|5912|9927)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
